import { render, staticRenderFns } from "./FollowContext.vue?vue&type=template&id=316387a4&scoped=true"
import script from "./FollowContext.vue?vue&type=script&lang=js"
export * from "./FollowContext.vue?vue&type=script&lang=js"
import style0 from "./FollowContext.vue?vue&type=style&index=0&id=316387a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316387a4",
  null
  
)

export default component.exports